<template>
  <div >
    <div class="top">
      <div class="wraper">
        <div class="w1180">
          <h1 class="slogan">{{$t("index.slogan")}}</h1>
          <search-box />
        </div>
      </div>
    </div>
    <div class="prompt">
      <div class="w1180">
        <div class="single" v-if="Object.keys(singleAds).length > 0" @click="toSpecialEvent('EventMacau')">
          <el-image class="r15 img" style="margin:0;" src="https://tourimage.huayitraveltd.com/appResource/4.jpg?v3" fit="cover"/>
        </div>
        <div class="multi" >
          <el-image class="r15 img" src="https://tourimage.huayitraveltd.com/appResource/chimelong2.jpg?v6!thumb1" fit="cover" @click="toSpecialEvent('EventChimelong')" />
          <el-image class="r15 img" src="https://tourimage.huayitraveltd.com/appResource/FFFF0397_ver1_LR-16x9.webp" fit="cover" @click="toSpecialEvent('EventDisney')" />
          <el-image class="r15 img" src="https://tourimage.huayitraveltd.com/appResource/oloq.jpg!thumb1" fit="cover" @click="toSpecialEvent('EventOLOQ')" />
        </div>
        <div class="wordList">
          <a class="word" @click="toHotel()">{{$t("index.jdyd")}}</a>
          <a class="word" @click="toPack(83)">{{$t("index.djtp")}}</a>
          <a class="word" @click="toTicket(2)">{{$t("index.mscj")}}</a>
          <a class="word" @click="toTicket(1)">{{$t("index.jdmp")}}</a>
          <a class="word" @click="toTour()">{{$t("index.gty")}}</a>
          <a class="word" @click="toTour('',14)">{{$t("index.hwsdy")}}</a>
          <a class="word" @click="toPack(85)">{{$t("index.hwly")}}</a>
          <a class="word" @click="toPack(84)">{{$t("index.wqdj")}}</a>
        </div>
      </div>
    </div>

    <div class="productList">
      <div class="w1180">
        <product-box :title="$t('index.jdtj')" :tab-list="hotelTab" style="margin-top: 25px" @tabChange="handleTabChange('hotel',...$event)" >
          <div class="productList" v-if="hList.length > 0">
            <div class="product" v-for="(item,index) in hList" :key="index" @click="toHotel(item.id,item.dataSource)">
              <el-image lazy style="width: 278px;height: 197px" fit="cover" :src="item.photo" />
              <div class="overlay">
                <div class="name">{{item.title}}</div>
                <div class="level">
                  <i class="el-icon-star-on yellow" v-for="i in item.start" :key="i" />
                </div>
              </div>
              <div class="price" v-if="item.price*1 > 0">
                <span class="from">{{$t("util.zdj")}}</span>
                <span class="content">{{ Vcurrency }} {{item.price}}</span>
                <span class="from">{{$t("util.q")}}</span>
              </div>
              <div class="price" v-else>
                <span class="from">{{$t("util.jrck")}}</span>
              </div>
            </div>
          </div>
          <div v-else class="empty">
            <el-empty :description="$t('index.zwcp')"></el-empty>
          </div>
        </product-box>
        <product-box :title="$t('index.cjtj')" :tab-list="couponTab" style="margin-top: 25px" @tabChange="handleTabChange('coupon',...$event)" >
          <div class="productList" v-if="cList.length > 0">
            <div class="product" v-for="(item,index) in cList" :key="index" @click="toTicket(item.id,item.dataSource)">
              <el-image lazy style="width: 278px;height: 197px" fit="cover" :src="item.photo" />
              <div class="overlay">
                <div class="name">{{item.title}}</div>
              </div>
              <div class="price" v-if="item.price*1 > 0">
                <span class="from">{{$t("util.zdj")}}</span>
                <span class="content">{{ Vcurrency }} {{item.price}}</span>
                <span class="from">{{$t("util.q")}}</span>
              </div>
              <div class="price" v-else>
                <span class="from">{{$t("util.jrck")}}</span>
              </div>
            </div>
          </div>
          <div v-else class="empty">
            <el-empty :description="$t('index.zwcp')"></el-empty>
          </div>
        </product-box>
        <product-box :title="$t('index.ddwl')" :tab-list="ticketTab" style="margin-top: 25px" @tabChange="handleTabChange('ticket',...$event)" >
          <div class="productList" v-if="tList.length > 0">
            <div class="product" v-for="(item,index) in tList" :key="index" @click="toTicket(item.id,item.dataSource)">
              <el-image lazy style="width: 278px;height: 197px" fit="cover" :src="item.photo" />
              <div class="overlay">
                <div class="name">{{item.title}}</div>
              </div>
              <div class="price" v-if="item.price*1 > 0">
                <span class="from">{{$t("util.zdj")}}</span>
                <span class="content">{{ Vcurrency }} {{item.price}}</span>
                <span class="from">{{$t("util.q")}}</span>
              </div>
              <div class="price" v-else>
                <span class="from">{{$t("util.jrck")}}</span>
              </div>
            </div>
          </div>
          <div v-else class="empty">
            <el-empty :description="$t('index.zwcp')"></el-empty>
          </div>
        </product-box>
        <product-box :title="$t('index.rmxc')" :tab-list="tourTab" style="margin-top: 25px" @tabChange="handleTabChange('tour',...$event)" >
          <div class="productList" v-if="trList.length > 0">
            <div class="product" v-for="(item,index) in trList" :key="index" @click="toTour(item.id)">
              <el-image lazy style="width: 278px;height: 197px" fit="cover" :src="item.photo" />
              <div class="overlay">
                <div class="name">{{item.title}}</div>
              </div>
              <div class="price" v-if="item.price*1 > 0">
                <span class="from">{{$t("util.zdj")}}</span>
                <span class="content">{{ Vcurrency }} {{item.price}}</span>
                <span class="from">{{$t("util.q")}}</span>
              </div>
              <div class="price" v-else>
                <span class="from">{{$t('util.jrck')}}</span>
              </div>
            </div>
          </div>
          <div v-else class="empty">
            <el-empty :description="$t('index.zwcp')"></el-empty>
          </div>
        </product-box>
      </div>
    </div>

    <div class="appDown">
      <div class="w1180">
        <div class="app">
          <div class="appImg">
            <div class="phone">
              <el-image style="width: 100%;height: 100%" :src="require('@/assets/app.jpg')" fit="fill" />
            </div>
          </div>
          <div class="content">
            <div class="title">{{$t("index.appTitle")}}</div>
            <div class="memo">{{$t("index.appDesc")}} </div>
            <div class="downLoad">
              <div class="left">
                <a href="https://tour.huayitraveltd.com/appDown/#/" target="_blank"><el-image src="https://pages.trip.com/images/download-button/zh-hk/ios-zh-hk.png" fit="cover" class="downBtn" /></a>
                <a href="https://tour.huayitraveltd.com/appDown/#/" target="_blank"><el-image src="https://pages.trip.com/images/download-button/zh-hk/android-zh-hk.png" fit="cover" class="downBtn" /></a>
              </div>
              <div class="right">
                <el-image :src="require('@/assets/qrCode.png')" fit="cover" class="qrCode" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="info">
      <div class="w1180">
        <div class="title">{{$t("index.hzhb")}}</div>
        <div class="subTitle">{{$t("index.hzhbdesc")}}</div>
        <div class="parent">
          <el-image fit="cover" src="https://www.huayitraveltd.com/img/suplist.png" class="icon" />
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import SearchBox from '../../components/global/searchBox/searchBox'
import ProductBox from '../../components/global/productBox'
import {advlist, appInfo} from '../../service/util'
import {hotelList} from '../../service/hotel'
import {ticketList} from '../../service/ticket'
import {tourList} from '../../service/tour'

export default {
  name: 'Index',
  components: {ProductBox, SearchBox},
  data () {
    return {
      advlist: [],
      hotelList: {},
      hList: [],
      couponList: {},
      cList: [],
      ticketList: {},
      tList: [],
      tourList: {},
      singleAds: {},
      trList: []
    }
  },
  computed: {
    hotelTab () {
      return [
        this.$t('index.rm'),
        this.$t('index.gat'),
        this.$t('index.rb'),
        this.$t('index.gn')
      ]
    },
    couponTab () {
      return [
        this.$t('index.rm')
      ]
    },
    ticketTab () {
      return [
        this.$t('index.rm'),
        this.$t('index.gat'),
        this.$t('index.gn')
      ]
    },
    tourTab () {
      return [
        this.$t('index.rm'),
        this.$t('index.zyx'),
        this.$t('index.gty')
      ]
    }
  },
  created () {
    advlist().then(res => {
      let adList = []
      if (res.code === 200) {
        for (let x in res.data) {
          adList.push({
            url: res.data[x].AdvUrl,
            src: res.data[x].AdvImg,
            title: res.data[x].Title,
            memo: res.data[x].AdvMemo
          })
        }
      }
      this.advlist = adList
    })
    appInfo().then(res => {
      if (res.code === 200) {
        let macauArea = res.data.indexAdv.filter((item) => item.id === 19)
        if (macauArea.length > 0) this.singleAds = macauArea[0]
      }
      console.log(res)
    })
    this.handleTabChange('hotel', this.hotelTab[0])
    this.handleTabChange('coupon', this.couponTab[0])
    this.handleTabChange('ticket', this.ticketTab[0])
    this.handleTabChange('tour', this.tourTab[0])
  },
  methods: {
    toSpecialEvent (type) {
      this.$router.push({
        name: type
      })
    },
    async handleTabChange (type, area) {
      if (type === 'hotel') {
        this.hList = await this.getHotel(area)
      } else if (type === 'coupon') {
        this.cList = await this.getCoupon(area)
      } else if (type === 'ticket') {
        this.tList = await this.getTicket(area)
      } else if (type === 'tour') {
        this.trList = await this.getTour(area)
      }
    },
    getTour (area) {
      return new Promise(resolve => {
        if (typeof this.tourList[area] !== 'undefined' && this.tourList[area].length > 0) {
          resolve(this.tourList[area])
        } else {
          const params = {
            tourType: (this.tourTab.indexOf(area) < 1 ? '' : area),
            limit: 4
          }
          tourList(params).then(res => {
            let hList = []
            if (res.code === 200) {
              const list = res.data.list
              for (let x in list) {
                hList.push({
                  id: list[x].id,
                  title: list[x].tourName,
                  photo: this.getPhoto('tour', list[x].adPhoto),
                  price: list[x].Money
                })
              }
              this.tourList[area] = hList
              resolve(hList)
            }
          })
        }
      })
    },
    getTicket (area) {
      return new Promise(resolve => {
        if (typeof this.ticketList[area] !== 'undefined' && this.ticketList[area].length > 0) {
          resolve(this.ticketList[area])
        } else {
          const params = {
            Area: (this.ticketTab.indexOf(area) < 1 ? '' : area),
            limit: 4,
            ClassID: 1
          }
          ticketList(params).then(res => {
            let hList = []
            if (res.code === 200) {
              const list = res.data.data
              for (let x in list) {
                hList.push({
                  id: list[x].Sid,
                  dataSource: list[x].dataSource,
                  title: list[x].SignName,
                  photo: this.getPhoto('ticker', list[x].SmallPhoto),
                  price: list[x].Price
                })
              }
              this.ticketList[area] = hList
              resolve(hList)
            }
          })
        }
      })
    },
    getCoupon (area) {
      return new Promise(resolve => {
        if (typeof this.couponList[area] !== 'undefined' && this.couponList[area].length > 0) {
          resolve(this.couponList[area])
        } else {
          const params = {
            Area: (this.couponTab.indexOf(area) < 1 ? '' : area),
            limit: 4,
            ClassID: 2
          }
          ticketList(params).then(res => {
            let hList = []
            if (res.code === 200) {
              const list = res.data.data
              for (let x in list) {
                hList.push({
                  id: list[x].Sid,
                  dataSource: list[x].dataSource,
                  title: list[x].SignName,
                  photo: this.getPhoto('ticker', list[x].SmallPhoto),
                  price: list[x].Price
                })
              }
              this.couponList[area] = hList
              resolve(hList)
            }
          })
        }
      })
    },
    getHotel (area) {
      return new Promise(resolve => {
        if (typeof this.hotelList[area] !== 'undefined' && this.hotelList[area].length > 0) {
          resolve(this.hotelList[area])
        } else {
          const params = {
            isPackege: '',
            kw: (this.hotelTab.indexOf(area) < 1 ? '' : area),
            orderby: '',
            page: 0,
            area: '',
            limit: 4
          }
          hotelList(params).then(res => {
            let hList = []
            if (res.code === 200) {
              const list = res.data.List
              for (let x in list) {
                hList.push({
                  id: list[x].id,
                  dataSource: list[x].dataSource,
                  title: list[x].HotelName,
                  photo: this.getPhoto('hotel', list[x].SmallPhoto),
                  price: list[x].Price,
                  start: list[x].HotelStar
                })
              }
              this.hotelList[area] = hList
              resolve(hList)
            }
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.r15{
  border-radius: 15px;
}
.appDown{
  position: relative;
  width: 100%;
  height: 550px;
  background: url(https://ws-s.tripcdn.cn/modules/ibu/online-home/7fbc7a38d69a62942ff425a2d986325c.7fbc7a38d69a62942ff425a2d986325c.jpg) 50% no-repeat;
  background-size: 100% 100%;
  margin: 0;
  display: flex;
  justify-content: center;
  overflow: hidden;
  box-sizing: border-box;
  padding: 80px 0;

  & .app{
    display: flex;
    flex-direction: row;
    align-items: center;

    & .appImg{
      position: relative;
      margin-right: 66px;
      overflow: hidden;
      height: 470px;
      & .phone{
        height: 605px;
        width: 248px;
        background-repeat: no-repeat;
        background-size: 100%;
        background-color: #e7ebf0;
        border-radius: 48px;
        position: relative;
        box-shadow: -8px 8px 24px rgba(69,88,115,.32), inset 0 0 8px rgba(133,146,166,.5);
        border: 14px solid #e7ebf0;
        box-sizing: content-box;
        overflow: hidden;
      }
    }
    & .content{
      position: relative;
      flex: 1 1;

      & .title{
        font-weight: 700;
        font-size: 36px;
        line-height: 40px;
        margin-bottom: 20px;
        color: #fff;
      }
      & .memo{
        font-size: 18px;
        color: #fff;
        line-height: 22px;
        margin-bottom: 25px;
      }
      & .downLoad{
        display: flex;
        flex-direction: row;
        & .left{
          display: flex;
          flex-direction: column;
          margin-right: 15px;

          & .downBtn{
            width: 180px;
            margin-bottom: 12px;
          }
        }
        & .right{
          display: inline-block;
          margin-left: 35px;
          & .qrCode{
            border-radius: 15px;
            display: inline-block;
            width: 128px;
            height: 128px;
          }
        }
      }
    }
  }
}
.info{
  display: inline-block;
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  padding:25px 0;

  & .subTitle{
    display: inline-block;
    width: 100%;
    color: #8592a6;
    line-height: 18px;
    text-align: center;
    font-size: 20px;
    font-weight: normal;
    margin-top: 10px;
  }
  & .title{
    font-size: 36px;
    line-height: 34px;
    text-align: center;
    padding-bottom: 24px;
    color: #0f294d;
    font-weight: 700;
    margin: 0;
  }
}
.empty{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 303px;
  margin:15px 0;
}
.productList{
  display: flex;
  flex-direction: row;
  margin: 15px 0;

  & .product:hover{
    box-shadow: 0 4px 10px 0 #aebfd4;
  }
  & .product{
    position: relative;
    display: inline-block;
    padding: 0 0 20px 0;
    width: 280px;
    margin: 0 9px;
    box-sizing: content-box;
    vertical-align: top;
    text-align: left;
    background: rgb(255, 255, 255);
    overflow: hidden;
    box-shadow: rgba(141,149,193,.24) 0 0 6px;
    border-radius: 5px;

    & .price{
      position: relative;
      box-sizing: border-box;
      display: flex;
      padding: 0 8px;
      flex-direction: row;
      width: 100%;
      font-size: 16px;
      color: #3264ff;
      letter-spacing: 0;
      text-align: left;
      line-height: 22px;
      align-items: flex-end;
      & .from{
        font-size: 14px;
        line-height: 18px;
        color: #455873;
      }
      & .content{
        font-weight: 700;
        margin:0 3px;
      }
    }
    & .overlay{
      position: relative;
      display: inline-block;
      box-sizing: border-box;
      width: 100%;
      padding: 0 8px;
      margin-top: 16px;
      font-size: 12px;
      & .level{
        line-height: 20px;
        box-sizing: content-box;
        display: inline-block;
        vertical-align: middle;
        padding-bottom: 2px;
        & .yellow{
          color: #ff9500;
          font-size: 16px;
          font-style: normal;
          -webkit-font-smoothing: antialiased;
        }
      }
      & .name{
        text-overflow: ellipsis;
        overflow: hidden;
        margin-right: 4px;
        color: #0f294d;
        font-weight: 700;
        font-size: 16px;
        line-height: 22px;
      }
    }
  }
}
.prompt{
  & .wordList{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    box-sizing: border-box;
    padding: 8px 15px;
    margin:5px 0;
    justify-content: space-between;

    & .word{
      max-width: 110px;
      display: block;
      font-size: 14px;
      color: #fff;
      text-decoration: none;
      padding: 10px 20px;
      border-radius: 3px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      cursor: pointer;
    }
    @for $i from 1 through 8 {
      & .word:nth-child(#{$i}){
        @if($i == 1){
          background-color: #5395e3;
        }@else if($i == 2){
          background-color: #5453e3;
        }@else if($i == 3){
          background-color: #9682ea;
        }@else if($i == 4){
          background-color: #b982ea;
        }@else if($i == 5){
          background-color: #d782ea;
        }@else if($i == 6){
          background-color: #ea82cd;
        }@else if($i == 7){
          background-color: #f77;
        }@else if($i == 8){
          background-color: #ea6d37;
        }
      }
    }
  }
  & .img:hover {
    box-shadow: 0 4px 10px 0 #aebfd4;
  }
  & .img{
    display: inline-block;
    margin:0 5px;
    width: 100%;
    border: 1px solid transparent;
    cursor: pointer;
  }
  .multi{
    display: flex;
    width: 100%;
    margin-top: 15px;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: center;

  }
  .single{
    display: inline-block;
    width: 100%;
    margin-top: 15px;
  }
}
.top{
  display: inline-block;
  background-image: url(https://www.huayitraveltd.com/img/bg-2.jpg);
  width: 100%;
  height: 350px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;

  & .wraper{
    display: inline-block;
    padding: 35px;
    width: 100%;
    box-sizing: border-box;
    margin-top: 80px;

    & .slogan{
      font-size: 38px;
      font-weight: 800;
      color: #fff;
      display: inline-block;
      width: 100%;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue